import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from 'react-router-dom'
// import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function PatientQues(props) {
    const [IntentList, setIntentList] = useState([])
    const [CategoryList, setCategoryList] = useState([])
    const [modal, setModal] = useState(false);
    const [formData, setName] = useState({ intents: "", IntDesc: "", Ans1: "", Ans2: "" });
    // const [formData2, setName2] = useState({ intents: "", Ans1: "", Ans2: "" });
    const [Emotion, setEmotion] = React.useState('');
    const [EType, setType] = React.useState('');
    const PtId = localStorage.getItem('PatQusId');
    const PtName = localStorage.getItem('PatName');
    const [value, setValue] = useState()
    const backchar = localStorage.getItem('BackQues');
    const UserRole = localStorage.getItem('URole');
    const QLength = localStorage.getItem('QuestionLength');
    const [PortalList, setPortalList] = useState([])
    const [PoralId, setPortalId] = React.useState('');
    const [suggetions, setsuggetions] = useState([])
    const PtGender = localStorage.getItem('PatGender');

    const [text, setText] = useState('')


    const navigate = useHistory();

    useEffect(() => {

        LoadIntents();
        LoadPortals();
        LoadCategory();

    }, [])
    const LoadCategory = () => {

        axios.get(`${process.env.REACT_APP_API_URL}/GetAllCategory`)
            .then(res => {
                //console.log("list", res.data)
                setCategoryList(res.data)
                // setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
            })
    }



    const LoadIntents = () => {
        let formDataSet = new FormData();
        formDataSet.append('PtId', PtId);

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getFilterMIntentsByPotID`,
            data: formDataSet,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            .then(res => {
                //console.log("list", res.data.length)
                setIntentList(res.data.length == 0 ? "" : res.data)
            })
    }
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`)
            .then(res => {
                //console.log("list", res.data)
                setPortalList(res.data)
            })
    }
    const onChangAuto = (text) => {
        //console.log("the event value", text)

        let matches = []
        if (text.length > 0) {
            matches = CategoryList.filter(item => {
                const regex = new RegExp(`${text}`, "gi");
                return item.category.match(regex)
            })
        }
        //console.log("matches", matches)
        setsuggetions(matches)
        setText(text)

    }
    const OnSuggestHandler = (text) => {
        //console.log("te selected value", text)
        setText(text);
        setsuggetions([])

    }
    const BackFunc = () => {
        // backchar == 'directQues' ? navigate.push('/PatientList') : navigate.push('/PtientIntentList');
        // UserRole === "Admin" ?  navigate.push('/PtientIntentList'): navigate.push('/ManagerPatientList')
        // UserRole === "Admin" ?  navigate.push('/PtientIntentList'): navigate.push('/PtientIntentList')
        QLength > 10 ? navigate.push('/PtientIntentList') : navigate.push('/PtientCusIntentList')
    }
    const IntentSubmit = async (e) => {
        e.preventDefault();

        //console.log("formData", formData)
        //console.log("dropdown", Emotion, EType)

        let formDataSet = new FormData();    //formdata object

        if (formData.intents === "" || formData.Ans1 === "" || formData.Ans1 == null || formData.Ans2 == null || formData.Ans2 === "" || Emotion == "") {
            if (formData.intents === "") {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

            } else if (formData.Ans1 === "" || formData.Ans1 == null) {
                Swal.fire({
                    title: "Error",
                    text: "Answer1 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (Emotion === "") {
                Swal.fire({
                    title: "Error",
                    text: "Emotion Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Answer2 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }


        } else {

            // //console.log("acual value", formData.IntDesc == null? "custom":formData.IntDesc)

            formDataSet.append('Intents', formData.intents);   //append the values with key, value pair
            formDataSet.append('Intent_Desc', formData.IntDesc == null || formData.IntDesc == "" ? "custom" : formData.IntDesc);
            formDataSet.append('Responce1', formData.Ans1 == null || formData.Ans1 == "" ? "0" : formData.Ans1);
            formDataSet.append('Responce2', formData.Ans2 == null || formData.Ans2 == "" ? "0" : formData.Ans2);
            formDataSet.append('Emotion', Emotion == "" ? "Neural" : Emotion);
            formDataSet.append('Emo_Type', EType == "" ? "No" : EType);
            formDataSet.append('P_id', PtId);
            formDataSet.append('Category', text);
            // formDataSet.append('PortId', PoralId);

            //console.log("all", EType == "" ? "Yes" : EType, text)
            if (EType == "") {
                setType("No")
            }

            if (EType === "Yes" && text === "") {
                Swal.fire({
                    title: "Error",
                    text: "Category Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (EType == "No" && text !== "") {
                Swal.fire({
                    title: "Error",
                    text: "Assessmen Field should be Yes",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

            } else {


                const config = {

                    headers: { 'content-type': 'multipart/form-data' }
                }
                var authOptions = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}/AddIntentsWithPatientId`,
                    data: formDataSet,
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                axios(authOptions)

                    .then(res => {
                        //console.log("get value", res);

                        //console.log("success")


                        setName({ intents: "", Ans1: "", Ans2: "" });
                        if (res.data.SuccessResult === "alredy") {
                            Swal.fire({
                                title: "Error",
                                text: "Question Already inserted",
                                icon: "error",
                                confirmButtonText: "Ok",
                            });
                        } else {
                            Swal.fire({
                                title: "Success",
                                text: "Question and Answer Added Successfully",
                                icon: "success",
                                confirmButtonText: "Ok",
                            }).then(function () {
                                // window.location.pathname = "/IntentAns";
                            });
                        }
                    })

                    .catch(error => {
                        //console.log("error occur", error);
                    })
            }
        }
    }

    const toggle2 = () => setModal(!modal);

    const handleChangePortal = (event) => {

        //console.log("the select portal", event.target.value)
        setPortalId(event.target.value);
        // setselectPortal(event.target.value)

        //console.log("selected Portal", event.target.value)

    };

    const handleChangeDrop = (event) => {

        //console.log("the intent val", event.target.value)
        setName({ intents: event.target.value })
        let formDataSet = new FormData();
        formDataSet.append('FInteid', event.target.value);
        setValue(event.target.value)

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getFilterIntentsByPid`,
            data: formDataSet,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        

    };

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    const handleChangeDrp = (event) => {

        setEmotion(event.target.value);
       

    };
    const handleChangeType = (event) => {


        setType(event.target.value);
        

    };

    const textFieldStyles = {
        width: '100%',// Customize the width of the input element
        height: '25px'
    };


    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Create Question and Answer</div>
                                <p>
                                    Case id:<span className='patietid me-3 ms-2'>{PtId}</span> Case Name:<span className='page me-3 ms-2'>{PtName}</span>
                                    Gender:<span  className='page me-3 ms-2'>{PtGender}</span>
                                </p>
                            </div>
                            <div className=" pull-right">

                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Question and Answer</header>

                                </div>
                                <div className="card-body " id="bar-parent">
                                    <form className="register-form" id="login-form" onSubmit={IntentSubmit}>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className='col-12 col-md-6'>
                                                    {/* <label for="simpleFormEmail">Question</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} /> */}
                                                    <label for="horizontalFormEmail" className="control-label">Intent</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                                    <select className="form-control select2" onChange={handleChangeDrop}>
                                                        <option value="" >--Select--</option>
                                                        {
                                                            IntentList.length > 0 ? IntentList.map((result, i) => {
                                                                return (
                                                                    <option value={result.intents} key={result.id}>{result.intents}</option>
                                                                )
                                                            })
                                                                : <option value="" >No Intent</option>
                                                        }
                                                    </select>
                                                </div>

                                                <div className='col-12 col-md-6'>
                                                    
                                                    <label for="horizontalFormEmail" className="control-label">Question Text</label>
                                                    <input type="text"
                                                        value={formData.IntDesc}
                                                        onChange={handleChange}
                                                        name="IntDesc" className="form-control" id="ans1"
                                                        placeholder="Question Text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="horizontalFormEmail" className="control-label">Answer 1</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans1}
                                                onChange={handleChange}
                                                name="Ans1" className="form-control" id="ans1"
                                                placeholder="Answer 1" />
                                        </div>
                                        <div className="form-group">
                                            <label for="horizontalFormEmail" className="control-label">Answer 2</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans2}
                                                onChange={handleChange}
                                                name="Ans2" className="form-control" id="ans2"
                                                placeholder="Answer 2" />
                                        </div>

                                        <div className="form-group">
                                            {/* <div className="card-body " id="bar-parent10"> */}
                                            <div className="form-group row">
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-12 control-label">Emotion
                                                    </label>
                                                    <select className="form-control  select2" value={Emotion} onChange={handleChangeDrp}>
                                                        <option value="">Select Emotion</option>
                                                        <option value="Sad">Sad</option>
                                                        <option value="Angry">Angry</option>
                                                        <option value="Happy">Happy</option>
                                                        <option value="Neural">Neutral</option>

                                                    </select>
                                                </div>
                                               
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-12 control-label">Assessment
                                                    </label>
                                                    <select className="form-control  select2" value={EType} onChange={handleChangeType}>
                                                        {/* <option value="">Select Type</option>                                                         */}

                                                        <option value="No">No</option>
                                                        <option value="Yes">Yes</option>


                                                    </select>
                                                </div>
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-12 control-label">Category
                                                    </label>
                                                    <input type="text" className='form-control  select2'
                                                        onChange={e => onChangAuto(e.target.value)} value={text}
                                                    />
                                                    {suggetions && suggetions.map((item, i) => <div key={i} className='col-md-4 justify-content'
                                                        onClick={() => OnSuggestHandler(item.category)} >{item.category}</div>)}
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>

                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                </div >
            </div >
        </>
    );
}

export default PatientQues;